import { h, render } from "omi";

import "./globals/styles.css";
import "./app";

render(<project-app />, "#app");
